import React, { useEffect } from "react";
import { HeaderTitle } from "../../components/headerTitle";
import { UploadReceivedDoc } from "../../components/uploadReceivedDoc";
import { ReceivedDocList } from "../../components/receivedDocList";
import { UnadjudicatedDocs } from "../../components/unadjudicatedDocs";
import {
  Grid,
  Button,
  Hidden,
  RadioGroup,
  FormControlLabel,
  Typography,
  Menu,
  Drawer,
  Tooltip,
  Backdrop,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  FormGroup,
  Checkbox,
  CircularProgress,
} from "@material-ui/core";
import { PublishTwoTone, CloudDownload } from "@material-ui/icons";
import "./HeaderReception.css";
import {
  RButton,
  RChip,
  RRadio,
  RButtonSecondary,
} from "../../components/ratifikaElements";
import moment from "moment";
import {
  ArrowRightAlt as ArrowDateIcon,
  Today as DateRangeIcon,
} from "@material-ui/icons";
import { subDays } from "date-fns";
import { DateRange } from "react-date-range";
import { es } from "date-fns/locale";
import { setConfigParam } from "../../store/actions/config";
import { fetch } from "../../store/fetch";
import { useDispatch, useSelector } from "react-redux";
import { FilterRecepcion } from "../../components/filterReception";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import {
  getDocumentStatusDescription,
  getDocumentTypeDesc,
} from "../../static/util";
import { Loading } from "../../components/skeleton/loading";
import { CompanyInfo } from "../../store/types/companies";
import Alert from "@material-ui/lab/Alert";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Colors } from "src/static/colors";
import axios from "axios";
import FileDownload from "js-file-download";
import { toast, ToastContainer } from "react-toastify";

export const Reception: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const companies = useSelector((state: any) => state.companiesInfo);
  const config = useSelector((state: any) => state.config);
  const [isOpenUploadXML, setIsOpenUploadXML] = React.useState(false);
  const [anchorElement, setAnchorElement] = React.useState<null | HTMLElement>(
    null
  );
  const [showUpdateAlert, setShowUpdateAlert] = React.useState<boolean>(false);
  const [showFilters, setShowFilters] = React.useState<boolean>(false);
  const [disabledBulkDownload, setDisabledBulkDownload] =
    React.useState<boolean>(true);
  const [showAlert, setShowAlert] = React.useState<boolean>(false);
  const [openDialogBulkDownload, setOpenDialogBulkDownload] =
    React.useState<boolean>(false);
  const [selectOptionPDF, setSelectOptionPDF] = React.useState<boolean>(false);
  const [selectOptionXML, setSelectOptionXML] = React.useState<boolean>(false);
  const [selectOptionCDR, setSelectOptionCDR] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [openDialogRequestProcess, setOpenDialogRequestProcess] =
    React.useState<boolean>(false);
  const classes = useStyles();

  const [dateRange, setDateRange] = React.useState([
    {
      startDate: subDays(new Date(), 30),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  let selectedDates: any = {
    startDate: dateRange[0].startDate,
    endDate: dateRange[0].endDate,
  };

  useEffect(() => {
    setDisabledBulkDownload(true);
    if (companies.find((c: CompanyInfo) => c.ruc === config.workspace)) {
      if (
        companies.find((c: CompanyInfo) => c.ruc === config.workspace).customize
          .descargaMasiva === "YES"
      ) {
        setDisabledBulkDownload(false);
      }
    }
  }, [config.workspace, companies]);

  const handleOpenMenuDates = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleCloseMenuDates = () => {
    setAnchorElement(null);
  };

  const handleCalendarChange = (item: any) => {
    setDateRange([item.selection]);
    selectedDates = item.selection;
  };

  const handleCalendarSelected = (e: any) => {
    const [start, end] = e;
    if (start === 0 && end === 0) {
      setAnchorElement(null);
      dispatch(
        setConfigParam(
          "receptionStartDate",
          moment(selectedDates.startDate).format("YYYY-MM-DD")
        )
      );
      dispatch(
        setConfigParam(
          "receptionEndDate",
          moment(selectedDates.endDate).format("YYYY-MM-DD")
        )
      );
      dispatch(setConfigParam("receptionPageCurrent", 0));
      fetch(["reception"]);
      setShowUpdateAlert(true);
    }
  };

  const handleDateTypeSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setConfigParam(
        "receptiondateType",
        (event.target as HTMLInputElement).value
      )
    );
    dispatch(setConfigParam("receptionPageCurrent", 0));
    fetch(["reception"]);
    setShowUpdateAlert(true);
  };

  const handleShowAlert = (value: boolean) => {
    setShowUpdateAlert(value);
  };

  // abrir filter click event
  const handleOpenFilterClick = () => {
    setShowFilters(true);
  };
  const handleCloseFilters = () => {
    setShowFilters(false);
  };
  const openPopOver = () => {
    setShowAlert(true);
  };
  const handleSelectbulkDownload = () => {
    setOpenDialogBulkDownload(true);
  };
  const handleCloseDialogBulkDownload = () => {
    setOpenDialogBulkDownload(false);
  };
  const handleCloseDialogRequestProcess = () => {
    setOpenDialogRequestProcess(false);
  };
  const generateBulkDownload = async () => {
    setLoading(true);
    const allDocument = await axios.get(
      `/api/reception/documents/all/${config.workspace}?dateOf=${
        config.receptiondateType
      }&startDate=${config.receptionStartDate}&endDate=${
        config.receptionEndDate
      }${
        config.receptionFilterSerie
          ? `&serie=${config.receptionFilterSerie}&seqInit=${config.receptionFilterInitSeq}&seqEnd=${config.receptionFilterEndSeq}`
          : ""
      }${
        config.receptionProveedorId
          ? `&proveedorId=${config.receptionProveedorId}`
          : ""
      }${config.receptiondocType ? `&docType=${config.receptiondocType}` : ""}${
        config.receptiondocState
          ? `&docStatus=${
              config.receptiondocState.split(",").includes("1-3")
                ? config.receptiondocState.replace("1-3", "1,3")
                : config.receptiondocState
            }`
          : ""
      }`
    );

    if (allDocument.data.result) {
      let body = allDocument.data.receivedDocs;
      let downloadLimit = await axios.get(`/api/bulkDownload/files/limit`);
      if (
        downloadLimit.data.result &&
        body.length <= downloadLimit.data.limit
      ) {
        let { data } = await axios.post(
          `/api/bulkDownload/reception/${config.workspace}/${selectOptionPDF}/${selectOptionXML}/${selectOptionCDR}`,
          body,
          {
            responseType: "blob",
          }
        );
        FileDownload(
          new Blob([data]),
          `DM-Doc-Recibidos-${config.workspace}.zip`
        );
        setLoading(false);
        handleCloseDialogBulkDownload();
      } else {
        setLoading(false);
        setOpenDialogRequestProcess(true);
        handleCloseDialogBulkDownload();
        let { data } = await axios.post(
          `/api/bulkDownload/reception/${config.workspace}/${selectOptionPDF}/${selectOptionXML}/${selectOptionCDR}`,
          body
        );
        if (data.result) {
          toast.info(
            "El processo de su ultima consultada de descarga masiva  ya fue generada"
          );
        }
      }
    }
  };
  return (
    <>
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={7000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/* <Snackbar
        open={showUpdateAlert}
        autoHideDuration={500}
        onClose={() => setShowUpdateAlert(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        message="Cargando..." /> */}

        <Grid container>
          <Hidden only={["xs", "sm", "md"]}>
            <Grid item xs={2} sm={2} className="linea">
              <HeaderTitle title="Documentos Recibidos" />
              {/* Fechas*/}
              <div>
                <RButton
                  style={{
                    alignContent: "center",
                    justifyContent: "center",
                    fontSize: 14,
                    height: 32,
                  }}
                  className="btn-date"
                  disabled={!config.workspace}
                  onClick={handleOpenMenuDates}
                >
                  <DateRangeIcon
                    style={{
                      fontSize: 18,
                      paddingRight: 5,
                      color: "white",
                    }}
                  />
                  <span style={{ color: "white" }}>
                    {moment(dateRange[0].startDate)
                      .locale("es")
                      .format("MMM DD")}
                  </span>
                  <ArrowDateIcon
                    style={{
                      fontSize: 22,
                      paddingLeft: 5,
                      paddingRight: 5,
                      color: "white",
                    }}
                  />
                  <span style={{ color: "white" }}>
                    {moment(dateRange[0].endDate).locale("es").format("MMM DD")}
                  </span>
                </RButton>
                <Menu
                  id="lock-menu"
                  anchorEl={anchorElement}
                  keepMounted
                  open={Boolean(anchorElement)}
                  onClose={handleCloseMenuDates}
                  getContentAnchorEl={null}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <div>
                    <DateRange
                      onChange={handleCalendarChange}
                      moveRangeOnFirstSelection={false}
                      ranges={dateRange}
                      months={2}
                      direction="horizontal"
                      locale={es}
                      rangeColors={["rgb(28, 108, 54)"]}
                      showMonthAndYearPickers={true}
                      maxDate={new Date()}
                      monthDisplayFormat="MMMM yyyy"
                      onRangeFocusChange={handleCalendarSelected}
                    />
                  </div>
                  <div>
                    <Grid style={{ marginLeft: 20 }}>
                      <RadioGroup
                        row
                        value={config.receptiondateType}
                        onChange={handleDateTypeSelect}
                      >
                        <FormControlLabel
                          value="uploaded"
                          control={<RRadio color="primary" />}
                          label={
                            <Typography style={{ fontSize: 14 }}>
                              Fecha de subida
                            </Typography>
                          }
                        />
                        <FormControlLabel
                          value="emitted"
                          control={<RRadio color="primary" />}
                          label={
                            <Typography style={{ fontSize: 14 }}>
                              Fecha de emisión
                            </Typography>
                          }
                        />
                      </RadioGroup>
                    </Grid>
                  </div>
                </Menu>
              </div>
              {/* End: Fechas */}
              <FilterRecepcion showAlert={handleShowAlert} />
            </Grid>
          </Hidden>
          <Hidden lgUp>
            <Drawer open={showFilters} onClose={handleCloseFilters}>
              <div style={{ marginLeft: "1rem", marginTop: "4rem" }}>
                <FilterRecepcion showAlert={handleShowAlert} />
              </div>
            </Drawer>
          </Hidden>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={10}
            className="padding-general"
          >
            {showUpdateAlert ? (
              (setTimeout(() => setShowUpdateAlert(false), 2200), (<Loading />))
            ) : (
              <>
                <Hidden lgUp>
                  <div style={{ paddingBottom: "10px", textAlign: "center" }}>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6}>
                        <HeaderTitle title="Documentos Recibidos" />
                      </Grid>

                      <Grid item xs={12} sm={6} md={6}>
                        {/* Fechas*/}
                        <div style={{ paddingBottom: "5px" }}>
                          <RButton
                            style={{
                              alignContent: "center",
                              justifyContent: "center",
                              fontSize: 14,
                              height: 30,
                              marginRight: ".7rem",
                              width: "210px",
                            }}
                            className="btn-date btnSizeLetra"
                            disabled={!config.workspace}
                            onClick={handleOpenMenuDates}
                          >
                            <DateRangeIcon
                              style={{
                                fontSize: 18,
                                paddingRight: 5,
                                color: "white",
                              }}
                            />
                            <span style={{ color: "white" }}>
                              {moment(dateRange[0].startDate)
                                .locale("es")
                                .format("MMM DD")}
                            </span>
                            <ArrowDateIcon
                              style={{
                                fontSize: 22,
                                paddingLeft: 5,
                                paddingRight: 5,
                                color: "white",
                              }}
                            />
                            <span style={{ color: "white" }}>
                              {moment(dateRange[0].endDate)
                                .locale("es")
                                .format("MMM DD")}
                            </span>
                          </RButton>
                          <Menu
                            id="lock-menu"
                            anchorEl={anchorElement}
                            keepMounted
                            open={Boolean(anchorElement)}
                            onClose={handleCloseMenuDates}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                          >
                            <div>
                              <DateRange
                                onChange={handleCalendarChange}
                                moveRangeOnFirstSelection={false}
                                ranges={dateRange}
                                months={2}
                                direction="horizontal"
                                locale={es}
                                rangeColors={["rgb(28, 108, 54)"]}
                                showMonthAndYearPickers={true}
                                maxDate={new Date()}
                                monthDisplayFormat="MMMM yyyy"
                                onRangeFocusChange={handleCalendarSelected}
                              />
                            </div>
                            <div>
                              <Grid style={{ marginLeft: 20 }}>
                                <RadioGroup
                                  row
                                  value={config.receptiondateType}
                                  onChange={handleDateTypeSelect}
                                >
                                  <FormControlLabel
                                    value="uploaded"
                                    control={<RRadio color="primary" />}
                                    label={
                                      <Typography style={{ fontSize: 14 }}>
                                        Fecha de subida
                                      </Typography>
                                    }
                                  />
                                  <FormControlLabel
                                    value="emitted"
                                    control={<RRadio color="primary" />}
                                    label={
                                      <Typography style={{ fontSize: 14 }}>
                                        Fecha de emisión
                                      </Typography>
                                    }
                                  />
                                </RadioGroup>
                              </Grid>
                            </div>
                          </Menu>
                        </div>

                        {/* End: Fechas */}
                        <div
                          style={{ textAlign: "center", paddingBottom: "5px" }}
                        >
                          <Button
                            style={{
                              alignContent: "center",
                              justifyContent: "center",
                              fontSize: 14,
                              height: 30,
                              backgroundColor: "#e6e6e6",
                              marginRight: ".7rem",
                              width: "210px",
                            }}
                            className="btnSizeLetra"
                            onClick={handleOpenFilterClick}
                          >
                            <FontAwesomeIcon
                              icon={faFilter}
                              style={{
                                fontSize: 13,
                                paddingLeft: 10,
                                paddingRight: 10,
                                color: "rgba(0, 0, 0, 0.54)",
                              }}
                            />
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              style={{ fontSize: 13 }}
                            >
                              Filtrar
                            </Typography>
                          </Button>
                        </div>

                        <div
                          style={{ textAlign: "center", paddingBottom: "5px" }}
                        >
                          <Button
                            style={{
                              alignContent: "center",
                              justifyContent: "center",
                              fontSize: 14,
                              height: 30,
                              marginRight: ".7rem",
                            }}
                            variant="contained"
                            color="default"
                            disableElevation
                            disabled={!config.workspace}
                            onClick={() => setIsOpenUploadXML(true)}
                            startIcon={<PublishTwoTone />}
                          >
                            Subir documentos
                          </Button>
                        </div>
                        <div
                          style={{
                            visibility: disabledBulkDownload
                              ? "hidden"
                              : "visible",
                          }}
                        >
                          <Tooltip title="Descarga Masiva" arrow>
                            <Button
                              style={{
                                alignContent: "center",
                                justifyContent: "center",
                                fontSize: 14,
                                height: 30,
                                backgroundColor: "#e6e6e6",
                                marginRight: ".7rem",
                                width: "210px",
                              }}
                              className="btnSizeLetra"
                              onClick={
                                disabledBulkDownload
                                  ? openPopOver
                                  : handleSelectbulkDownload
                              }
                            >
                              <CloudDownload
                                style={{
                                  fontSize: 22,
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  color: "rgba(0, 0, 0, 0.54)",
                                }}
                              />
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                style={{ fontSize: 13 }}
                              >
                                Descarga Masiva
                              </Typography>
                            </Button>
                          </Tooltip>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Hidden>
                <Hidden only={["xs", "sm", "md"]}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      flexWrap: "wrap",
                      flexDirection: "row-reverse",
                      paddingBottom: 8,
                    }}
                    className="header-container-rec"
                  >
                    <Button
                      variant="contained"
                      color="default"
                      disableElevation
                      disabled={!config.workspace}
                      onClick={() => setIsOpenUploadXML(true)}
                      startIcon={<PublishTwoTone />}
                    >
                      Subir documentos
                    </Button>
                    <div
                      style={{
                        visibility: disabledBulkDownload ? "hidden" : "visible",
                      }}
                    >
                      <Tooltip title="Descarga Masiva" arrow>
                        <Button
                          style={{
                            alignContent: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            backgroundColor: "#e6e6e6",
                            marginRight: ".7rem",
                            width: "210px",
                          }}
                          className="btnSizeLetra"
                          onClick={
                            disabledBulkDownload
                              ? openPopOver
                              : handleSelectbulkDownload
                          }
                        >
                          <CloudDownload
                            style={{
                              fontSize: 22,
                              paddingLeft: 10,
                              paddingRight: 10,
                              color: "rgba(0, 0, 0, 0.54)",
                            }}
                          />
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            style={{ fontSize: 13 }}
                          >
                            Descarga Masiva
                          </Typography>
                        </Button>
                      </Tooltip>
                    </div>

                    <div style={{ display: "flex" }}>
                      {config.receptionFilterSerie && (
                        <RChip
                          icon={
                            <FontAwesomeIcon
                              icon={faFilter}
                              style={{
                                fontSize: 12,
                                paddingLeft: 8,
                                color: "white",
                              }}
                            />
                          }
                          label={`${config.receptionFilterSerie} / ${config.receptionFilterInitSeq}~${config.receptionFilterEndSeq}`}
                          /*  onDelete={() => {
                    dispatch(setConfigParam("receptionFilterSerie", null));
                    dispatch(setConfigParam("receptionFilterInitSeq", null));
                    dispatch(setConfigParam("receptionFilterEndSeq", null));
                    fetch(["emission"]);
                    setShowUpdateAlert(true);
                  } } */
                          color="secondary"
                          size="small"
                          style={{ marginRight: 5 }}
                        />
                      )}
                      {config.receptiondocType &&
                        config.receptiondocType
                          .split(",")
                          .map((t: string, index: number) => (
                            <RChip
                              key={index}
                              icon={
                                <FontAwesomeIcon
                                  icon={faFilter}
                                  style={{
                                    fontSize: 12,
                                    paddingLeft: 8,
                                    color: "white",
                                  }}
                                />
                              }
                              label={getDocumentTypeDesc(t)}
                              /*   onDelete={() => {
                      dispatch(
                        setConfigParam(
                          "receptiondocType",
                          config.receptiondocType.replace(`${t},`, "").replace(`,${t}`, "").replace(t, "")
                        )
                      );
                      fetch(["emission"]);
                      setShowUpdateAlert(true);
                    } } */
                              color="secondary"
                              size="small"
                              style={{ marginRight: 5 }}
                            />
                          ))}

                      {config.receptiondocState &&
                        config.receptiondocState
                          .split(",")
                          .map((s: string, index: number) => (
                            <RChip
                              key={index}
                              icon={
                                <FontAwesomeIcon
                                  icon={faFilter}
                                  style={{
                                    fontSize: 12,
                                    paddingLeft: 8,
                                    color: "white",
                                  }}
                                />
                              }
                              label={getDocumentStatusDescription(
                                s === "1-3" ? "1" : s
                              )}
                              /*  onDelete={() => {
                      dispatch(
                        setConfigParam(
                          "receptiondocState",
                          config.receptiondocState.replace(`${s},`, "").replace(`,${s}`, "").replace(s, "")
                        )
                      );
                      fetch(["emission"]);
                      setShowUpdateAlert(true);
                    } } */
                              color="secondary"
                              size="small"
                              style={{ marginRight: 5 }}
                            />
                          ))}

                      {config.receptionProveedorName && (
                        <RChip
                          icon={
                            <FontAwesomeIcon
                              icon={faFilter}
                              style={{
                                fontSize: 12,
                                paddingLeft: 8,
                                color: "white",
                              }}
                            />
                          }
                          label={`${config.receptionProveedorName}`}
                          color="secondary"
                          size="small"
                          style={{ marginRight: 5 }}
                        />
                      )}
                    </div>
                  </div>
                </Hidden>
                <Grid item md={12} style={{ overflowX: "auto" }}>
                  <ReceivedDocList text="yey" />
                  <UnadjudicatedDocs />
                </Grid>

                <UploadReceivedDoc
                  key={Date.now() + 25}
                  title="Carga manual de XML"
                  subtitle="Agrega los documentos donde figures como receptor"
                  isOpen={isOpenUploadXML}
                  closeForm={() => setIsOpenUploadXML(!isOpenUploadXML)}
                />
              </>
            )}
          </Grid>
        </Grid>
      </React.Fragment>
      <Backdrop
        open={showAlert}
        onClick={() => {
          setShowAlert(false);
        }}
        style={{ color: "#fff" }}
        className={classes.backdrop}
      >
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={showAlert}
          onClose={() => {
            setShowAlert(false);
          }}
          autoHideDuration={6000}
          style={{ marginTop: "50px" }}
        >
          <Alert
            onClose={() => {
              setShowAlert(false);
            }}
            severity="warning"
          >
            ¡Lo sentimos!
            <br />
            Parece que esta funcionalidad no está incluida en su plan actual. Contacte con un ejecutivo de EXIMIO para más información.
          </Alert>
        </Snackbar>
      </Backdrop>
      <Dialog
        open={openDialogBulkDownload}
        onClose={handleCloseDialogBulkDownload}
      >
        <DialogTitle>Seleccione los tipos de archivos a descargar</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <FormGroup
              row
              style={{ display: "flex", justifyContent: "center" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ color: Colors.primary }}
                    onChange={() => setSelectOptionPDF(!selectOptionPDF)}
                    checked={selectOptionPDF}
                  />
                }
                label="PDF"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ color: Colors.primary }}
                    onChange={() => setSelectOptionXML(!selectOptionXML)}
                    checked={selectOptionXML}
                  />
                }
                label="XML"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ color: Colors.primary }}
                    onChange={() => setSelectOptionCDR(!selectOptionCDR)}
                    checked={selectOptionCDR}
                  />
                }
                label="CDR"
              />
            </FormGroup>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <RButtonSecondary
            onClick={handleCloseDialogBulkDownload}
            color="primary"
          >
            Cancelar
          </RButtonSecondary>
          <RButton
            onClick={() => {
              if (selectOptionPDF || selectOptionXML || selectOptionCDR) {
                generateBulkDownload();
              }
            }}
            autoFocus
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress
                  variant="indeterminate"
                  size={14}
                  style={{ marginRight: 5 }}
                />
                Cargando...
              </>
            ) : (
              <>CONFIRMAR</>
            )}
          </RButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDialogRequestProcess}
        onClose={handleCloseDialogRequestProcess}
      >
        <DialogTitle>SOLICITUD POR PROCESAR</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Puedes continuar usando el sistema de Ratifika mientras tu reporte
            se procesa. Te aparecerá una notificación cuando esté listo para
            descargar desde Mis Reportes
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 999,
      color: "#fff",
    },
  })
);
